import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Helmet from 'react-helmet';
import kebabCase from 'lodash/fp/kebabCase';
import Entities from 'html-entities/lib/html5-entities';
import { injectGlobal } from 'emotion';

// Import PrismJS theme
import 'prismjs/themes/prism.css';

// Import fonts
import 'typeface-space-mono/index.css';
import 'typeface-source-sans-pro/index.css';

// Import components
import Header from '../components/header';
import Footer from '../components/footer';
import OverlayMenu from '../components/overlay-menu';
import MailChimpSubscribe from '../components/mailchimp-subscribe';
import SocialIcons from '../components/social-icons';

// Import `League Spartan` typeface
import '../fonts/league-spartan/webfonts/stylesheet.css';

// Import config and presets
import config, { mailChimpURL } from '../utils/config';
import { toRem } from '../utils/functions';
import { baselineGrid } from '../utils/presets';

// Inject global styles
/* eslint-disable */
injectGlobal`
.gatsby-image-wrapper {
  /* Enhance blur-up effect for gatsby images */
  img[src^="data:image"] {
    filter: blur(calc(${toRem(baselineGrid)} + 1vw));
    transform: scale(1.2);
  }
}`;
/* eslint-enable */

// Import SVG sprite symbols
const shapes = require.context('../assets/svg-sprite', true, /\.svg$/);
shapes.keys().reduce((images, key) => {
  images[kebabCase(key.replace(/.svg/, ''))] = shapes(key);
  return images;
}, {});

const entities = new Entities();

const Layout = props => {
  const { children, location } = props;
  const isThemePage = !!location.pathname.match('/theme/');
  const isArticlePage = !!location.pathname.match('/article/');
  const isSupportPage = !!location.pathname.match('/support');
  const excludeNewsletter = (() => isSupportPage)();

  return (
    <div
      className={classnames(
        'page',
        { 'theme-permalink': isThemePage },
        { 'dark-header': isThemePage || isSupportPage || isArticlePage }
      )}
    >
      <Helmet
        titleTemplate={entities.decode(`%s &bull; ${config.siteTitle}`)}
        defaultTitle={config.siteTitle}
      >
        <meta name="twitter:site" content="@pixelmoxie" />
        <meta name="og:type" content="website" />
        <meta name="og:site_name" content="Pixelmoxie" />
        <link rel="canonical" href={`${config.siteUrl}${location.pathname}`} />
        <html lang="en" />

        {/* Favicon stuff from realfavicongenerator.net */}
        <meta name="apple-mobile-web-app-title" content="pixelmoxie.net" />
        <meta name="application-name" content="pixelmoxie.net" />
        <meta name="msapplication-TileColor" content="#f12267" />
        <meta name="theme-color" content="#ffffff" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png?v=xQzlYR7X0A" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png?v=xQzlYR7X0A" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png?v=xQzlYR7X0A" />
        <link rel="manifest" href="/site.webmanifest?v=xQzlYR7X0A" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg?v=xQzlYR7X0A" color="#f12267" />
        <link rel="shortcut icon" href="/favicon.ico?v=xQzlYR7X0A" />
      </Helmet>
      <Header siteTitle={config.siteTitle} />
      <OverlayMenu />
      {children()}
      {!excludeNewsletter && <MailChimpSubscribe url={mailChimpURL} />}
      <SocialIcons />
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  data: PropTypes.object,
  children: PropTypes.func,
  location: PropTypes.object,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js